(function (angular) {
    /*
        The purpose of "use strict" is to indicate that the code should be executed in "strict mode".
        With strict mode, you can not, for example, use undeclared variables.
    */
    'use strict';

    /*
        Gets the main angular module of the project
    */
    var app = angular.module('enervee');

    app.filter('sentenceCase', function(){
        return function(input){
            if (!angular.isString(input)) {
                return;
            }

            input = input.toLowerCase();
            return input.charAt(0).toUpperCase() + input.slice(1);
        };
    });

    /**
     * A wrapper for the built in Angular currency filter. This allows it to fit to our needs and still
     * format for other languages.
     *
     * If number is greater than 100, it is rounded to the nearest integer. If less than 100, it will
     * display the cent value if it's not 0, i.e. $25 and $50.99
     *
     * Usage example:
     * {{ myValue | toCurrency : symbol : fractionSize }}
     *
     * @param input
     * @param symbol
     * @param fractionSize
     */
    app.filter('toCurrency', [
        '$filter',
        function(
            $filter
        ) {
            return function(input, symbol, fractionSize) {
                if (input === null) return input;

                input = Math.abs(input);

                if (fractionSize === undefined) {
                    if (input < 100 && input % 1 !== 0) {
                        fractionSize = 2;
                    } else {
                        fractionSize = 0;
                    }
                } else {
                    fractionSize = 2;
                }

                return $filter('currency')(input, symbol, fractionSize);
            };
        }
    ]);

    /**
     * Takes a decimal and converts it to a percentage. If decimalPoints is specified, it will keep that amount of points.
     *
     * Usage example:
     * {{ myValue | toPercentage }}
     *
     * @param input
     * @param decimalPoints
     */
    app.filter('percentage', [
        '$filter',
        function(
            $filter
        ) {
            return function(input, decimalPoints) {
                if (decimalPoints) {
                    return $filter('number')(input * 100, decimalPoints) + '%';
                }
                return Math.floor(input*100) + '%';
            };
        }
    ]);

    /**
     * Runs $sce.trustAsHtml on the given code as an angular filter
     *
     */
    app.filter("trust", [
        '$sce',
        function(
            $sce
        ) {
            return function(htmlCode){
                if (typeof htmlCode !== 'string') {
                    return htmlCode;
                }
                return $sce.trustAsHtml(htmlCode);
            };
        }
    ]);

    /**
     * Replaces spaces with <br> for the given string
     */
    app.filter('spaceToBreak', [
        '$sce',
        function (
            $sce
        ) {
            return function (input) {
                if (input) {
                    return $sce.trustAsHtml(input.replace(/ /g, '<br>'));
                } else {
                    return '';
                }
            };
        }
    ]);


    /**
     * Returns either 'a' or 'an' based on the given sentence/word
     */
    app.filter('aOrAn', [
        function () {
            return function (input) {

                var firstCharOfSentence = input.charAt(0).toLowerCase();

                var prefix = 'a';
                if (['a', 'e', 'i', 'o', 'u'].indexOf(firstCharOfSentence) !== -1) {
                    prefix = 'an';
                }

                return prefix;

            };
        }
    ]);


    /**
     * Inserts the company/utility name into the input text. The position can be changed to insert at any point in the
     * text. The default position is 0, or prepend.
     *
     *
     * Usage example:
     * {{ "instant rebate" | insertCompanyName:1 }}
     * Yields:
     * instant Company-Name rebate
     *
     * @param input
     * @param position
     */
    app.filter('insertCompanyName', [
        '$filter',
        'UtilService',
        function(
            $filter,
            UtilService
        ) {
            return function(input, position) {

                // assign default value if not passed
                position = position || 0;

                // check input and position meet requirements.
                if (input === undefined) {
                    return input;
                }

                if (position < 0) {
                    return input;
                }

                if (typeof input !== "string") {
                    return input;
                }

                // if the feature is enabled, then insert the name into the specified position.
                if (UtilService.isFeatureEnabled('insert_name_into_rebate')) {
                    var inputArray = input.split(" ");
                    var utilityName = UtilService.getSiteSetting('title');
                    inputArray.splice(position, 0, utilityName);
                    return inputArray.join(" ");
                }

                // fallback if not enabled
                return input;

            };
        }
    ]);


    /**
     * Joins the list of strings with a comma-space delimiter.
     * @param {Array} items
     * @returns {string|*}
     */
    app.filter('joinCommas', [
        '$log',
        function (
            $log
        ) {
            return function(items) {
                if (items && Array.isArray(items)) {
                    return items.join(", ");
                } else {
                    $log.warn('Invalid input, expected array, received ' + items);
                    return items;
                }
            };
        }
    ]);


    /**
     * Returns a string lowercased, with all spaces and dashes replaced with
     * underscores
     *
     * Usage example:
     * {{ "Most Energy-Efficient Washers" | toSnakeCase }}
     * Yields:
     * most_energy-efficient_washers
     *
     * @param input
     */
    app.filter('snakeCase',
        function () {
            return function(input) {
                return input.toLowerCase().replace(/[ \-]/g, '_');
            };
        }
    );


    /**
     * Returns a string with all the HTML tags removed. If an argument is passed,
     * only removes the specific tags as specified by the argument.
     *
     * @param {String} input
     * @param {String} [tagNames] a comma-separated array of tag names to
     * specifically remove.
     *
     * @example
     * {{ "<div>Specially <strong>styled</strong> content" | stripTags }}
     * --> "Specially styled content"
     *
     * {{ "<p>This <span data-foo="bar">content</span> has <em>extra</em> tags.</p>" | stripTags:"p,span" }}
     * --> "This content has <em>extra</em> tags."
     */
    app.filter('stripTags',
        function stripTags() {
            return function(input, tagNames) {
                tagNames = tagNames || '';
                tagNames = tagNames.split(/, ?/g);
                var re = /<\S[^><]*>/g;
                if (tagNames.length) {
                    re = new RegExp('<\/?(' + tagNames.join('|') + ')(\\s[^><]*)?>', 'g');
                }
                if (angular.isString(input)) {
                    return input.replace(re, '');
                }
                return input;
            };
        }
    );

    /**
     * Overrides the existing "lowercase" filter in order to prevent
     * all-uppercase acronyms from being forced to lowercase (e.g. "LED")
     *
     * @param {String} input
     * @return {String}
     */
    app.filter('lowercase',
        function specialLowercase() {
            return function(input, force) {
                force = force || false;

                if (!force) {
                    var re = (/(\w*[a-z]\w*[a-z]\w*)/g);
                    return input.replace(re, function(str) {
                        return str.toLowerCase();
                    });
                }
                return input.toLowerCase();
            };
        }
    );

    app.filter('phoneNumber', function() {
        /*
        Format phone number as: c (xxx) xxx-xxxx
            or as close as possible if phone number length is not 10
            if c is not '1' (country code not USA), does not use country code
        */

        return function (number) {
            /*
            @param {Number | String} number - Number that will be formatted as telephone number
            Returns formatted number: (###) ###-####
                if number.length < 3: (##
                else number.length < 4: (###)
                else if number.length < 7: (###) ###-

            Does not handle country codes that are not '1' (USA)
            */
            if (!number) { return ''; }

            number = String(number);

            // Will return formattedNumber.
            var formattedNumber = number;

            // if the first character is '1', strip it out and add it back
            var c = (number[0] === '1') ? '1 ' : '';
            number = number[0] === '1' ? number.slice(1) : number;

            // strip out extra numbers
            number = number.substring(0, 10);

            // # (###) ###-#### as c (area) front-end
            var area = number.substring(0,3);
            var front = number.substring(3, 6);
            var end = number.substring(6, 10);

            if (area) {
                formattedNumber = (c + "(" + area);
                if (area.length === 3) {
                    formattedNumber += ") ";
                }
            }
            if (front) {
                formattedNumber += front;
                if (front.length === 3) {
                    formattedNumber += "-";
                }
            }
            if (end) {
                formattedNumber += (end);
            }
            return formattedNumber;
        };
    });

    app.filter('orderObjectBy', function(){
        /**
         * Allows ng-repeat to order by an object's property.
         */
        return function(input, attribute) {
            if (!angular.isObject(input)) {
                return input;
            }

            var array = [];
            for (var objectKey in input) {
                array.push(input[objectKey]);
            }

            array.sort(function (a, b) {
                a = parseInt(a[attribute]);
                b = parseInt(b[attribute]);
                return a - b;
            });
            return array;
        };
    });
})(angular);
